import React from 'react';

const PluginContext = React.createContext();

export default PluginContext;
